import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import { BlockInputField } from '../../../../components/FormElements/BlockInputField';

export const StyledSearchInput = styled(BlockInputField)`
  width: 100%;

  ${media.md`
    width: 245px;
  `};
`;
